import { render, staticRenderFns } from "./AddAttrField.vue?vue&type=template&id=5e673bbc&"
import script from "./AddAttrField.vue?vue&type=script&lang=ts&"
export * from "./AddAttrField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports